module.exports = __webpack_public_path__ + "img/local.55658fb7.png";